import script from "./SignupFirstStepForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupFirstStepForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupFirstStepForm.vue?vue&type=style&index=0&id=4884c8eb&lang=scss"

const __exports__ = script;

export default __exports__